export default __webpack_public_path__ + "static/media/icon-rectangle-miss.959b09c0.svg";